module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product4-3a2b36c5b053dcf76f02ea00081450ac.jpg";